import React from 'react';
import { connect } from 'react-redux';
import { CONFIRMATION, notApplicable, REVIEW, ExperienceRewardsTermsLink, GM_REWARDS_DEALERS_LINK } from '../../shared/Constants/SharedConstants';
import { AuthenticatedFlow, EditAppointmentFlow } from '../../shared/RoutingFlow/FlowComponentsConstants';

class Disclaimer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPrivacyPopup: false,
        };
    }

    togglePrivacyPopup() {
        this.setState({ showPrivacyPopup: !this.state.showPrivacyPopup });
        window.scrollTo(0, 0);
    }

    consent = () => {
        const showPrivacyDetails = this.props.countryOptions.SHOW_PRIVACY_DETAILS;
        const showPrivacyDetailsModal = this.props.countryOptions.SHOW_PRIVACY_DETAILS_MODAL;
        if (showPrivacyDetails === 'true' && showPrivacyDetailsModal === 'true') {
            return (
                <div className="view-privacy-policy">
                    <span
                        id="btnPrivacy"
                        className="contact-disclaimer-label"
                        dangerouslySetInnerHTML={{
                            __html: `${this.props.vTranslations.CONSENT_PART_ONE} ${this.props.vTranslations.CONSENT_LINK} ${this.props.vTranslations.CONSENT_PART_TWO}`,
                        }}
                    />
                </div>
            );
        }
        if (showPrivacyDetails === 'true' && showPrivacyDetailsModal === 'false') {
            return (
                <span
                    id="btnPrivacy"
                    className="contact-disclaimer-label"
                    dangerouslySetInnerHTML={{
                        __html:
                            this.props.vTranslations.CONTACT_CONSENT === undefined
                                ? `${this.props.vTranslations.CONSENT_PART_ONE} ${this.props.vTranslations.CONSENT_LINK} ${this.props.vTranslations.CONSENT_PART_TWO}`
                                : this.props.vTranslations.CONTACT_CONSENT,
                    }}
                />
            );
        }
        return null;
    };
    render() {
        let { countryOptions, softEnroll } = this.props;

        const rewardsLink = (
            <a href={ExperienceRewardsTermsLink} target="_blank">
                {ExperienceRewardsTermsLink.toString().replace("https://", '')}
            </a>
        )

        const rewardsDealersLink = (
            <a href={GM_REWARDS_DEALERS_LINK} target="_blank">
                {GM_REWARDS_DEALERS_LINK.toString().replace("https://", '')}
            </a>
        )

        if (
            (this.props.countryOptions.SHOW_PRIVACY_DETAILS === 'true' && this.props.headerNav === REVIEW) ||
            countryOptions.GET_LOYALTY === 'true'
        ) {
            return (
                <div className="submit-appointment-disclaimer paper">
                    <div className="submit-appointment-disclaimer-title headline3"></div>
                    <div className="submit-appointment-disclaimer-statement">
                        {this.props.headerNav === REVIEW && this.props.country !== 'US' && this.consent()}
                        {countryOptions.GET_LOYALTY === 'true' && (
                            <>
                                {countryOptions.GET_LOYALTY_CARD_FOOTER === 'true' ? (
                                    <>
                                        {(this.props.active &&
                                            this.props.usePoints &&
                                            this.props.headerNav === CONFIRMATION) ||
                                        (this.props.active &&
                                            this.props.headerNav === REVIEW &&
                                            this.props.useMyRewardsIndicator !== notApplicable && this.props.redeemEligible) ||
                                        (this.props.flowSource === EditAppointmentFlow &&
                                            this.props.useMyRewardsIndicator !== notApplicable) ||
                                        (this.props.headerNav === CONFIRMATION &&
                                            this.props.flowSource === AuthenticatedFlow &&
                                            this.props.active === undefined &&
                                            this.props.enrollMyRewardsError === undefined) ||
                                        (this.props.headerNav === CONFIRMATION &&
                                            this.props.flowSource !== AuthenticatedFlow &&
                                            this.props.active === undefined &&
                                            this.props.useMyRewardsIndicator === notApplicable) ? (
                                            <>
                                                <p>
                                                    {softEnroll?this.props.vTranslations.DISCLAIMER_PART_ONE_NON_MEMBER:this.props.vTranslations.DISCLAIMER_PART_ONE} {rewardsLink}{' '}
                                                    {this.props.vTranslations.DISCLAIMER_PART_TWO}
                                                </p>

                                                <p>
                                                    {this.props.vTranslations.DISCLAIMER_REDEEM_PART1} {rewardsDealersLink} {this.props.vTranslations.DISCLAIMER_REDEEM_PART2}
                                                </p>
                                                <p>
                                                    {softEnroll?(this.props.vTranslations.DISCLAIMER_ELIGIBILITY || "DISCLAIMER_ELIGIBILITY"):null}
                                                </p>
                                            </>
                                        ) : null}
                                    </>
                                ) : (
                                    <>
                                        {this.props.isBannerDisplayed ||
                                        this.props.useMyRewardsIndicator !== notApplicable ? (
                                            <p>
                                                {this.props.vTranslations.DISCLAIMER_PART_ONE} {rewardsLink}{' '}
                                                {this.props.vTranslations.DISCLAIMER_PART_TWO}
                                            </p>
                                        ) : null}
                                    </>
                                )}
                            </>
                        )}
                    </div>
                </div>
            );
        }
        return null;
    }
}

const mapStateToProps = (state) => ({
    countryOptions: state.countryOptionsReducer.countryOptions,
    brands: state.prefillReducer.dealerSummaryObject.dealershipSummary.brands,
    vTranslations: state.countryOptionsReducer.translations,
    active: state.myRewardsReducer.active,
    enrollRewards: state.myRewardsReducer.enrollRewards,
    enrollMyRewardsError: state.myRewardsReducer.enrollMyRewardsError,
    softEnroll: state.myRewardsReducer.softEnroll,
    preferredBrand: state.myRewardsReducer.preferredBrand,
    themeMake: state.prefillReducer.themeMake,
    make: state.prefillReducer.make,
    flowSource: state.prefillReducer.flowSource,
    headerNav: state.headReducer.headerNavigation,
    showErrorMessage: state.myRewardsReducer.showError,
    useMyRewardsIndicator: state.prefillReducer.useMyRewardsIndicator,
    usePoints: state.myRewardsReducer.usePoints,
    isBannerDisplayed: state.myRewardsReducer.isBannerDisplayed,
    redeemEligible: state.myRewardsReducer.redeemEligible,
    country: state.prefillReducer.country,
});

export default connect(mapStateToProps)(Disclaimer);
